import React, { PropsWithChildren, useContext } from 'react';
import { useAsyncCallback, UseAsyncReturn } from 'react-async-hook';
import { connectApiAxios, leadApiAxios } from '../config/axios';

type IntegrationsContextProps = {
  searchExperian: UseAsyncReturn<any,
    [{ companyRegisteredName: string; countryCode?: string }]>;
  getCodatRedirect: UseAsyncReturn<any, [name: string]>;
  createLead: UseAsyncReturn<any,
    [{ firstname: string, lastname: string, email: string }]>;
  createCompany: UseAsyncReturn<any, [{ name: string; lastname: string, email: string }]>;
};

const IntegrationsContext = React.createContext<IntegrationsContextProps>({} as any);

const IntegrationsContextProvider: React.FC<PropsWithChildren<any>> = ( props ) => {
  const { children } = props;

  const x_api_key = process.env['REACT_APP_X_API_KEY'] || '';

  const searchExperian = useAsyncCallback(async ( params ) => {
    const { companyRegisteredName, countryCode } = params;

    const { data } = await leadApiAxios.get<any>(
      `/companies/search?country=${countryCode}&name=${companyRegisteredName}`,
      {
        headers: {
          'x-api-key': x_api_key
        }
      }
    );

    return data;
  });

  const getCodatRedirect = useAsyncCallback(async ( leadId: string ) => {

    const { data } = await leadApiAxios.post<any>(
      `/leads/${leadId}/codat`,
    );

    return data;
  });

  const createLead = useAsyncCallback(async ( params ) => {
    const { data } = await connectApiAxios.post<any>(
      `/integrations/hubspot/lead`,
      { params }
    );

    return data;
  });

  const createCompany = useAsyncCallback(async ( params ) => {
    const { data } = await connectApiAxios.post<any>(
      `/integrations/hubspot/company`,
      { params }
    );

    return data;
  });

  return (
    <IntegrationsContext.Provider
      value={{
        searchExperian,
        getCodatRedirect,
        createLead,
        createCompany,
      }}
    >
      {children}
    </IntegrationsContext.Provider>
  );
};

export const useIntegrations = () => useContext(IntegrationsContext);

export default IntegrationsContextProvider;
